import '../administrative/subscriptionCategories/module.js';

angular.module('signalview.orgNotifications', [
    'signalboost',
    'signalview.appNotifications',
    'signalview.orgSubscription',
    'sfx.external',
    'signalview.subscriptionInfo',
]);
